import Plausible from 'plausible-tracker'
import { APP_ENV } from '../environment'

export const initializePlausible = () => {
  if (APP_ENV !== 'production') return

  const domain = window.location.hostname.includes('admin.attensi.com')
    ? 'admin.attensi.com'
    : 'manager.attensi.com'

  const plausible = Plausible({
    trackLocalhost: false,
    apiHost: 'https://plausible.attensi.com',
    domain,
  })

  plausible.enableAutoOutboundTracking()
  plausible.enableAutoPageviews()
}
